<template>
  <div class="login-page flex-grow-1">
    <b-container class="d-flex h-100">
      <b-form class="m-auto auth-form" @submit.prevent="onSubmit">
        <h3 align="center" class="mb-3">Регистрация</h3>

        <b-overlay
          :show="loader"
          rounded="sm"
          variant="white"
          opacity=".35"
          blur="4px"
          class=""
        >
          <b-form-group id="input-group-1" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="$v.form.name.$model"
              :state="validateState('name')"
              type="text"
              placeholder="Имя, Фамилия"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!$v.form.name.minLength"
              >Минимальная длина:
              {{ $v.form.name.$params.minLength.min }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!$v.form.name.required"
              >Необходимо ввести Имя, Фамилию</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group id="input-group-1" label-for="input-1">
            <b-form-input
              id="input-2"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              type="email"
              placeholder="E-mail"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!$v.form.email.email"
              >Некорректный E-mail</b-form-invalid-feedback
            >
            <b-form-invalid-feedback v-if="!$v.form.email.required"
              >Необходимо ввести E-mail</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group id="input-group-2" label-for="input-2">
            <b-form-input
              id="input-3"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              type="password"
              placeholder="Пароль"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!$v.form.password.required"
              >Необходимо ввести пароль</b-form-invalid-feedback
            >
            <b-form-invalid-feedback v-if="!$v.form.password.minLength"
              >Минимальная длина пароля:
              {{ $v.form.password.$params.minLength.min }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-checkbox
            id="checkbox-1"
            v-model="form.status"
            :state="validateState('status')"
            @change="$v.form.status.$touch()"
            name="checkbox-1"
            class="mb-3"
          >
            Я прочитал и принял пользовательское соглашение
          </b-form-checkbox>

          <b-button type="submit" variant="warning" size="lg" block
            >Зарегистрироваться</b-button
          >
          <p class="text-center pt-4">
            <router-link to="/login" class="text-secondary">
              Уже зарегистрированы?
            </router-link>
          </p>
        </b-overlay>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import { email, required, minLength, sameAs } from 'vuelidate/lib/validators';
import msg from '@/utils/messages';

export default {
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_REGISTER,
      titleTemplate: `%s ${this.siteName || ''}`
    };
  },
  data() {
    return {
      loader: false,
      form: {
        name: '',
        email: '',
        password: '',
        status: false
      }
    };
  },
  computed: {
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  },
  validations: {
    form: {
      name: { required, minLength: minLength(3) },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      status: { sameAs: sameAs(() => true) }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.$v.$touch();
        return;
      }

      try {
        this.loader = true;
        await this.$store.dispatch('register', this.form);
        this.$router.push(`/login?msg=${msg.COMFIRM_EMAIL}`);
      } catch (e) {
        this.loader = false;
      }
    }
  },
  mounted() {
    // this.$toast('sdf', {title: 'Hey!'})
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  background-color: #f5f5f5;
}
</style>
